var _path, _circle, _circle2, _path2, _circle3, _circle4, _circle5, _circle6, _circle7, _path3, _circle8, _circle9, _circle0, _circle1, _circle10, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.6902 29.6639C91.7366 17.5762 84.1717 24.4889 81.9165 30.4275C74.5195 24.1133 66.9302 30.3484 68.9165 35.752C60.3469 36.8795 62.4163 46.4277 66.7945 48.3814C61.0212 51.9896 64.5395 61.0103 71.9813 59.2062C71.4165 65.9275 76.9165 66.4275 81.002 62.1379C86.4165 70.9277 92.9165 67.9277 95.4351 62.1379C99.4041 67.9111 106.034 64.167 106.485 60.1077C116.917 62.9277 115.917 53.4277 113.927 50.185C120.917 41.9277 116.709 36.203 109.643 35.752C111.447 23.8447 101.825 26.4313 97.6902 29.6639Z",
    fill: "#52537A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.9903,
    cy: 74.6387,
    r: 2.93171,
    fill: "#52537A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.8714,
    cy: 80.9535,
    r: 2.02965,
    fill: "#52537A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2396 129.999H62.8496C67.4002 129.999 71.0891 126.31 71.0891 121.76V116.457C71.0891 114.769 70.5816 113.112 69.4193 111.888C66.8175 109.148 61.274 104.53 53.4841 104.571C45.7074 104.611 40.2292 109.18 37.6574 111.895C36.5024 113.115 36 114.764 36 116.444V121.76C36 126.31 39.689 129.999 44.2396 129.999Z",
    fill: "#CC78CB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5438,
    cy: 92.993,
    r: 13.993,
    fill: "#CC78CB"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.7261,
    cy: 91.146,
    r: 3.62256,
    fill: "#F1F1F1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.7261,
    cy: 91.146,
    r: 3.62256,
    fill: "#F1F1F1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.937,
    cy: 91.146,
    r: 3.62256,
    fill: "#F1F1F1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.937,
    cy: 91.146,
    r: 3.62256,
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3516 56.744H89.9214C91.7724 56.744 93.273 55.2434 93.273 53.3924V51.2356C93.273 50.5489 93.0666 49.875 92.5937 49.377C91.5354 48.2623 89.2805 46.3842 86.1119 46.4005C82.9486 46.4168 80.7203 48.2753 79.6742 49.38C79.2043 49.8761 79 50.5468 79 51.2301V53.3924C79 55.2434 80.5005 56.744 82.3516 56.744Z",
    fill: "#CC78CB"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.1372,
    cy: 41.6919,
    r: 5.69186,
    fill: "#CC78CB"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.3622,
    cy: 40.9403,
    r: 1.47353,
    fill: "#F1F1F1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.3622,
    cy: 40.9403,
    r: 1.47353,
    fill: "#F1F1F1"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7372,
    cy: 40.9403,
    r: 1.47353,
    fill: "#F1F1F1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.7372,
    cy: 40.9403,
    r: 1.47353,
    fill: "#F1F1F1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 101.577,
    y1: 48.931,
    x2: 107.062,
    y2: 43.4461,
    stroke: "#F1BBEE",
    strokeWidth: 1.56532
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 99.5534,
    y1: 46.5774,
    x2: 102.162,
    y2: 49.1863,
    stroke: "#F1BBEE",
    strokeWidth: 1.56532
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmo1);
export default __webpack_public_path__ + "static/media/emo-1.c5911e1ef8ae2c968f644d1ad4528812.svg";
export { ForwardRef as ReactComponent };